var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0274 4.28008C14.9482 3.96369 14.7869 3.6738 14.5598 3.43969C14.3327 3.20558 14.0479 3.03554 13.734 2.94675C12.5874 2.66675 8.00071 2.66675 8.00071 2.66675C8.00071 2.66675 3.41404 2.66675 2.26737 2.97341C1.95354 3.0622 1.66869 3.23224 1.4416 3.46635C1.21452 3.70046 1.05323 3.99035 0.97404 4.30675C0.764183 5.47045 0.661531 6.65095 0.667373 7.83341C0.659893 9.02478 0.762552 10.2143 0.97404 11.3867C1.06135 11.6933 1.22624 11.9722 1.4528 12.1964C1.67936 12.4206 1.95992 12.5826 2.26737 12.6667C3.41404 12.9734 8.00071 12.9734 8.00071 12.9734C8.00071 12.9734 12.5874 12.9734 13.734 12.6667C14.0479 12.578 14.3327 12.4079 14.5598 12.1738C14.7869 11.9397 14.9482 11.6498 15.0274 11.3334C15.2356 10.1785 15.3383 9.00697 15.334 7.83341C15.3415 6.64205 15.2389 5.45255 15.0274 4.28008Z",
    stroke: "#1D1D1B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50098 10.0136L10.3343 7.83356L6.50098 5.65356V10.0136Z",
    stroke: "#1D1D1B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLine);
export default __webpack_public_path__ + "static/media/youtube_line.46d303c3b112a0befe4e317fec73b6df.svg";
export { ForwardRef as ReactComponent };